import { BUSINESS, PRIVACY_SMS_CLAUSE } from "@/data/legal";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-page" className="pt-28 md:pt-36 pb-24 md:pb-32">
      <section className="mx-auto max-w-3xl px-6 md:px-10">
        <p className="label-eyebrow">Legal</p>
        <h1 className="font-display text-bone text-5xl md:text-6xl mt-5 leading-[0.95]">Privacy Policy</h1>
        <p className="mt-6 text-bone/60 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>

        <div className="prose-luxe mt-12 space-y-10 text-bone/75 leading-relaxed">
          <section data-testid="privacy-business-section">
            <h2 className="font-display text-bone text-3xl">1. Who We Are</h2>
            <p className="mt-4">
              <span className="text-bone">{BUSINESS.legalName}</span> (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) operates this website and the services described on it.
              {" "}{BUSINESS.description}
            </p>
            <p className="mt-4">Contact: <a className="text-brass hover:text-champagne" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">2. Information We Collect</h2>
            <p className="mt-4">When you interact with our site we may collect:</p>
            <ul className="mt-4 list-disc pl-5 space-y-2">
              <li>Identity &amp; contact info you submit (name, email, mobile number, city).</li>
              <li>Communications you send through forms (stewardship signups, House Alerts, Chime In, event inquiries).</li>
              <li>Stewardship and order details required to fulfill services.</li>
              <li>Basic technical data (device, browser, IP, pages visited) for security and analytics.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">3. How We Use Information</h2>
            <ul className="mt-4 list-disc pl-5 space-y-2">
              <li>To provide and improve our products, events, and stewardships.</li>
              <li>To send service-related communications (confirmations, order updates, stewardship updates).</li>
              <li>To send marketing communications (only when you have opted in, including SMS).</li>
              <li>To comply with legal obligations and protect our rights.</li>
            </ul>
          </section>

          <section data-testid="privacy-sms-clause-section" className="border border-brass/30 bg-espresso/15 p-8">
            <h2 className="font-display text-bone text-3xl">4. SMS &amp; Mobile Data Protections</h2>
            <p data-testid="privacy-sms-clause" className="mt-4 whitespace-pre-line text-bone">
              {PRIVACY_SMS_CLAUSE}
            </p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">5. House Alerts (SMS Program)</h2>
            <p className="mt-4">
              When you opt in to House Alerts you may receive recurring automated promotional and personalized marketing text messages
              regarding Weekly Drops, Menu Releases, Event Announcements, Order Updates, Stewardship Updates, and Promotional Offers.
              Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply.
              Reply <span className="text-brass">STOP</span> to unsubscribe and <span className="text-brass">HELP</span> for assistance.
            </p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">6. Cookies &amp; Analytics</h2>
            <p className="mt-4">We use a small number of cookies and similar technologies to operate the site, remember preferences, and measure performance. You can control cookies through your browser settings.</p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">7. How We Share Information</h2>
            <p className="mt-4">We share personal information only with the service providers necessary to operate the business (e.g., hosting, email delivery, payment processing, SMS aggregators). We do not sell personal information. SMS opt-in data is governed by Section 4 above.</p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">8. Data Retention &amp; Security</h2>
            <p className="mt-4">We retain personal information only as long as needed for the purposes described and as required by law, and we use commercially reasonable safeguards to protect it.</p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">9. Your Choices</h2>
            <ul className="mt-4 list-disc pl-5 space-y-2">
              <li>You may unsubscribe from SMS at any time by replying STOP.</li>
              <li>You may unsubscribe from marketing email through the link in any email.</li>
              <li>You may contact us to access, correct, or delete your personal information.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">10. Children</h2>
            <p className="mt-4">This site is not directed to children under 13 and we do not knowingly collect their personal information.</p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">11. Changes to This Policy</h2>
            <p className="mt-4">We may update this Privacy Policy from time to time. We will post the updated version on this page with a new effective date.</p>
          </section>

          <section>
            <h2 className="font-display text-bone text-3xl">12. Contact</h2>
            <p className="mt-4">Questions? Write to <a className="text-brass hover:text-champagne" href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>.</p>
            <p className="mt-4">
              Call or Text:{" "}
              <a
                data-testid="privacy-phone"
                href="tel:+15592366336"
                className="text-brass hover:text-champagne"
              >
                (559) 236-6336
              </a>
            </p>
            <p data-testid="privacy-phone-sms-consent" className="mt-3 text-lavender text-sm leading-relaxed">
              By contacting us via SMS with your mobile number, you consent to receive text messages
              from The Uncanny House LLC. Msg&amp;Data rates may apply. Reply &ldquo;STOP&rdquo; at any time to opt out.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
